
import { Product } from "../types";
import { Toaster } from "../helper/toaster";
import { createContext, useContext, useState } from "react";

interface ToasterContextProps {
    showToaster: (title: string, product: Product|null) => void;
}

const ToasterContext = createContext<ToasterContextProps>({
    showToaster: (title: string, product: Product|null) => {}
});

export const ToasterProvider = (props: {children: React.ReactNode}) => {

    const { children } = props;

    const [isShowToaster, setIsShowToaster] = useState<boolean>(false);
    const [title, setTitle] = useState<string>('');
    const [content, setContent] = useState<string|React.ReactNode>('');
    const [product, setProduct] = useState<Product|null>(null);

    const showToaster = (title: string, product: Product|null) => {
        setTitle(title);
        setIsShowToaster(true);
        setContent(content);
        setProduct(product);
        setTimeout(() => setIsShowToaster(false), 3000);
    }

    return (
        <ToasterContext.Provider value={{ showToaster }}>
            { children }
            <Toaster 
                title={title} 
                showToaster={isShowToaster} 
                handleToggleToster={setIsShowToaster}  
                content={(
                    <div>
                        <img src={product?.image} alt={product?.name} width="50" className="me-2"/>
                        <span>{product?.name} added to cart</span>
                    </div>
                )}
            />
        </ToasterContext.Provider>
    )
}

export const useToaster = () => useContext(ToasterContext);